import en from '@/lang/en.json'

export type MessageKey = keyof typeof en

/** UI text by key, with every `{name}` filled from `values`. Plain function, so Zod rules and server code use it too. */
export const t = (key: MessageKey, values: Record<string, string | number> = {}) =>
  en[key].replace(/\{(\w+)\}/g, (placeholder, name: string) => String(values[name] ?? placeholder))
